export const PRIVACY_CONSENT_COOKIE = "_b71ed078";
export const CSRF_COOKIE = "csrfToken";

export const PERFORMANCE_COOKIES = ["_ga"];
